import { z } from 'zod';

import { UserSchema } from '../users/user.schema.js';
import { type SignupRequest, type SignupResponse } from './signup.dto.js';

export const SignupRequestSchema: z.ZodType<SignupRequest> = z.object({
  email: z.string().trim().pipe(z.email()),
  password: z.string().min(1),
});

export const SignupResponseSchema: z.ZodType<SignupResponse> = z.object({
  user: UserSchema,
});
